// import { AddRegistryMethodType } from '../Catalog.telemetry.types';

import type { ProductUniversalItemSource } from '@graphql/generated-base';
import { RegistryItemSource } from '../Catalog.constants';
import type { AddRegistryMethodType, PagesForTelemetry } from '../Catalog.telemetry.types';

export function generateRegistryItemMetadataSourceFromCatalog(method: AddRegistryMethodType, pageValue: PagesForTelemetry): RegistryItemSource {
  let source = RegistryItemSource.catalogShop;
  if (method === 'related products quick add') {
    source = RegistryItemSource.recommendedCatalogShop;
  } else if (pageValue === 'searchResults') {
    source = RegistryItemSource.catalogSearch;
  }
  return source;
}

export const universalItemSourceToRegistryItemSource = (source?: ProductUniversalItemSource): RegistryItemSource | null => {
  return source ? RegistryItemSource[source] : null;
};
